import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Locale from '../data/localization'

import Badge from './Badge';

class List extends Component {

    static propTypes = {
        items: PropTypes.array,
        onClick: PropTypes.func.isRequired
    }

    handleClick(id, type) {
        if (this.props.onClick) {
            this.props.onClick(id, type);
        }
    }

    render() {
        const { items, onBackClick } = this.props;

        return (
            <ul className="List">
                {onBackClick && 
                    <li className="List-item List-item--back" key="-1" onClick={() => onBackClick()}>
                        {Locale.search.listBack}
                    </li>
                }
                {items.map(item => {
                    return (
                        <li
                            className="List-item"
                            key={item.children.length ? `c${item.id}` : item.id}
                            onClick={() => this.handleClick(item.id, item.children.length ? 'group' : 'item')}>
                            {item.name}
                            {item.note && <span className="List-note">{item.note}</span>}
                            {item.children.length ? <Badge value={item.children.length} /> : null}
                        </li>
                    )
                })}
            </ul>
        )
    }
}

export default List;


// WEBPACK FOOTER //
// ./components/List.js